// extracted by mini-css-extract-plugin
export default {"contentBlock":"about_contentBlock__pXiCe"};